export const TARIFF_FEATURES = {
  projects: { level: 1, title: 'Создание и ведение балконов', image: '/images/tariff/projects.svg' },
  stats: { level: 2, title: 'Статистика компании', image: '/images/tariff/stats.svg' },
  employees: { level: 2, title: 'Сотрудники', image: '/images/tariff/employees.svg' },
  prices: { level: 2, title: 'Настройка цен', image: '/images/tariff/prices.svg' },
  windows_partners: { level: 2, title: 'Поставщики окон', image: '/images/tariff/windows.svg' },
};

export const TARIFF_FEATURE_PATH = {
  projects: '/',
  stats: '/',
  employees: '/team',
  prices: '/prices',
  windows_partners: '/windows_partners',
};

export function featureAllowed(level, featureKey) {
  const feature = TARIFF_FEATURES[featureKey];
  if (!feature) return false;
  const current = Number(level);
  if (!Number.isFinite(current)) return false;
  return current >= feature.level;
}

export function accessLevel(tariff) {
  if (!tariff || tariff.state !== 'active') return 0;
  const level = Number(tariff.level);
  return Number.isFinite(level) ? level : 0;
}
